module.exports = __webpack_public_path__ + "static/media/level-arrow.2baa5802.svg";